import { useState } from "react";
import { Link } from "react-router-dom";
import { Loader2, Mail, CheckCircle2 } from "lucide-react";
import api from "@/lib/api";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email, origin: window.location.origin });
      setSent(true);
    } catch { setSent(true); }
    finally { setLoading(false); }
  };

  return (
    <div className="min-h-[80vh] grid place-items-center px-4 py-16" data-testid="forgot-password-page">
      <div className="w-full max-w-md eyw-card p-8">
        <span className="grid place-items-center h-12 w-12 rounded-full bg-[#144F75]/10 text-[#144F75] mb-4"><Mail size={22} /></span>
        <h1 className="font-serif text-3xl text-[#1A242B]">Reset your password</h1>
        {sent ? (
          <div className="mt-6" data-testid="forgot-sent">
            <p className="text-[#4A5D6B] flex items-start gap-2"><CheckCircle2 size={18} className="text-[#5C8A72] mt-0.5" /> If an account exists for that email, we've sent a reset link. Check your inbox.</p>
            <Link to="/login" className="eyw-btn-ghost !py-2.5 text-sm mt-6 inline-flex">Back to login</Link>
          </div>
        ) : (
          <form onSubmit={submit} className="mt-6 space-y-4">
            <p className="text-[#4A5D6B] text-sm">Enter your email and we'll send you a link to set a new password.</p>
            <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@example.com" data-testid="forgot-email" className="eyw-input w-full" required />
            <button type="submit" disabled={loading} data-testid="forgot-submit" className="eyw-btn w-full disabled:opacity-60">
              {loading && <Loader2 className="animate-spin" size={18} />} Send reset link
            </button>
            <Link to="/login" className="block text-center text-sm text-[#144F75]">Back to login</Link>
          </form>
        )}
      </div>
    </div>
  );
}
